import { render, staticRenderFns } from "./YoutubeSlider.vue?vue&type=template&id=1179a49a&scoped=true&"
import script from "./YoutubeSlider.vue?vue&type=script&lang=js&"
export * from "./YoutubeSlider.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeSlider.vue?vue&type=style&index=0&id=1179a49a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1179a49a",
  null
  
)

export default component.exports